import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from "rxjs";
import {ContentService} from "../../services/content.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Artist} from "../../model/artist";
import {Location} from "@angular/common";
import {Melody} from "../../model/melody";
import {DeviceService} from "../../services/device.service";
import {MainPageBanner} from "../../model/main-page-banner";

@Component({
  selector: 'app-artist-page',
  templateUrl: './artist-page.component.html',
  styleUrls: ['./artist-page.component.css'],
  host: {
    class: 'app-page'
  }
})
export class ArtistPageComponent implements OnInit, OnDestroy {
  artistId: number;
  artist: Artist;

  melodies: Melody[];
  melodiesCount: number;

  page: number;
  pageSize: number;
  loadSubscription: Subscription;
  loadInProgress: boolean;

  subscription = new Subscription();
  mainPageSpecialBanners: ReadonlyArray<MainPageBanner>;

  constructor(private readonly route: ActivatedRoute,
              private readonly router: Router,
              private readonly contentService: ContentService,
              private readonly location: Location,
              readonly deviceService: DeviceService) {
    this.artistId = null;
    this.artist = null;

    this.melodies = [];
    this.melodiesCount = 0;

    this.page = 0;
    this.pageSize = deviceService.artistPageMelodiesSize;
    this.loadSubscription = null;
    this.loadInProgress = false;
    this.mainPageSpecialBanners = [];
  }

  ngOnInit(): void {
    this.subscription.add(
      this.route.params.subscribe(params => {
        this.artistId = parseInt(params['id']);

        this.loadArtist();
      }));

    this.subscription.add(
      this.contentService.mainPageSpecialBanners.subscribe(banners => this.mainPageSpecialBanners = banners)
    )
  }

  loadArtist(): void {
    this.contentService.getArtist(this.artistId)
      .subscribe(value => {
        if (value == null) {
          this.router.navigate(['error', '404']);
        } else {
          this.artist = value;
          this.loadMelodies();
        }
      });

    this.contentService.getArtistMelodiesCount(this.artistId)
      .subscribe(count => this.melodiesCount = count);
  }

  loadMelodies(): void {
    this.page = 0;
    this.melodies = [];
    if (this.loadSubscription) {
      this.loadSubscription.unsubscribe();
      this.loadSubscription = null;
    }
    this.loadInProgress = false;

    this.loadMelodiesPage();
  }

  loadMelodiesPage(): void {
    if (!this.loadInProgress && (this.melodies.length < this.melodiesCount || this.page == 0)) {
      this.loadInProgress = true;

      this.loadSubscription = this.contentService.getArtistMelodies(this.artistId, this.page, this.pageSize)
        .subscribe((melodies) => {
          this.melodies = this.melodies.concat(melodies);
          this.page++
          this.loadInProgress = false;
          this.loadSubscription = null;
        });
    }
  }

  back(): void {
    this.location.back();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
